import Abstract from './abstract';
import Body from '../body';

export default () => {
  const steps = [
    {
      selector: '[data-guide="course-edit@interacive:create"]',
      content: <Body title="新建互动题，开启丰富课堂" description="可以自由选择互动模板" />,
    },
  ];

  return <Abstract steps={steps} scene="mixedCourseware" />;
};
